import React, { useMemo } from 'react';
import { Text, Link } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';
import { linkStyles } from '../../SelectedWidgets.styles';

const ImageUploadInfo: React.FC<{ type: string; content: any }> = ({ type, content }) => {
    if (type !== 'image-upload') return null;
    const { imageUrl, alt: altText, author, authorUrl } = content || {};
    const isUnsplashImage = useMemo(() => imageUrl?.includes('unsplash') && authorUrl?.includes('unsplash'), [imageUrl, authorUrl]);
    if (!altText && !author && !isUnsplashImage) return null;

    return (
        <>
            {altText && (
                <Text variant="xLarge" style={{ fontWeight: 'bold', marginBottom: 10 }}>
                    {altText}
                </Text>
            )}
            {author && <Text variant="medium">{IvicosStrings.personalMeetingCornerStrings.imageUpload.author.replace('{authorName}', author)}</Text>}
            {isUnsplashImage && (
                <>
                    <Text variant="medium">{IvicosStrings.personalMeetingCornerStrings.imageUpload.sourceUnsplash}</Text>
                    <Text variant="medium">
                        <Link style={linkStyles} href={imageUrl} target="_blank" rel="noopener noreferrer">
                            {IvicosStrings.personalMeetingCornerStrings.imageUpload.imageLink}
                        </Link>
                    </Text>
                </>
            )}
        </>
    );
};

export default ImageUploadInfo;
